import React from 'react';
import moment from 'moment';

import config from '@config';

/**
 * Get the on air class for program in grid and list view
 * @param  {moment} date     Date and time of today
 * @param  {moment} start    Starting time of the program
 * @param  {string} duration A duration string of the program
 * @return {Boolean}         boolean that say if program is on air.
 */
export const getOnAirClass = (date, start, duration) => {
  if (
    start &&
    date.isSameOrAfter(start) &&
    date.isSameOrBefore(
      moment(start).add(moment.duration(duration).as('minutes'), 'm'),
    )
  ) {
    return 'is-onair';
  } else if (
    start &&
    date.isSameOrAfter(start) &&
    date.isSameOrAfter(
      moment(start).add(moment.duration(duration).as('minutes'), 'm'),
    )
  ) {
    return 'has-aired';
  }

  return '';
};

/**
 * Get on demand icon markup
 * @param  {moment} date      Date and time of today
 * @param  {Object}           p Program
 * @param  {Object}           nid Network ID
 * @param  {Object}           sid Service ID
 * @return {React markup}     Icon markup
 */
export const getOnDemandIcon = (currentTime, p, nid, sid) => {
  const network = window.drupalSettings.tvguide_livestream_channels.find(
    n => n.network_id == nid,
  );
  const service = network.live_services.find(s => s.service_id == sid);
  const onAirClass = getOnAirClass(currentTime, p.start_time, p.duration);
  if (
    (p.on_demand &&
      moment().isBetween(
        p.on_demand.start_of_availability,
        p.on_demand.end_of_availability,
      )) ||
    (onAirClass == 'is-onair' && service)
  ) {
    return <span className="icon-play" />;
  }

  return null;
};

export const getAppDownloadLink = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  let storeLink = config.appstore.default;

  Object.keys(config.appstore).forEach(target => {
    if (userAgent.indexOf(target) > -1) {
      storeLink = config.appstore[target];
    }
  });

  return storeLink;
};

export const isInViewport = elem => {
  const bounding = elem.getBoundingClientRect();
  return (
    bounding.top >= 0 &&
    bounding.left >= 0 &&
    bounding.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    bounding.right <=
      (window.innerWidth || document.documentElement.clientWidth)
  );
};

/**
 * Check if two dates are the same day
 * @param  {Date} dateA   date to compare
 * @param  {Date} dateB   compared date
 * @return {Boolean}      true if same, false if not
 */
export const isSameDate = (dateA, dateB) => {
  return (
    dateA.getUTCFullYear() === dateB.getUTCFullYear() &&
    dateA.getUTCMonth() === dateB.getUTCMonth() &&
    dateA.getUTCDate() === dateB.getUTCDate()
  );
};

/**
 * Prorata of pixels from the beginning of day by the ratio
 * @param  {moment} date  A moment object
 * @param  {Number} ratio Minutes / pixel ratio
 * @return {Number}       Calculated number of pixels
 */
export const getMinutesFromStartOfDay = (date, beginning, ratio) => {
  return date.diff(beginning, 'minutes') * ratio;
};
